(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5822],{

/***/ 74528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38579);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _async_image_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38992);
/* harmony import */ var _async_image_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_async_image_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19142);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_environment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_operators_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76459);






var imageLoader = function(param) {
    var src = param.src;
    if (src.startsWith("http")) {
        return src;
    }
    return "".concat(_environment__WEBPACK_IMPORTED_MODULE_3__.environment.web_cdn_url, "web/assets/img/").concat(src);
};
var AsyncImage = function(param) {
    var imgSrc = param.imgSrc, coverArtId = param.coverArtId, width = param.width, height = param.height, imageClass = param.imageClass, isFullWidth = param.isFullWidth, layout = param.layout, alt = param.alt, objectFitStyle = param.objectFitStyle, _isPriority = param.isPriority, isPriority = _isPriority === void 0 ? false : _isPriority, sizes = param.sizes, style = param.style, className = param.className, _hasNoDefaultStyles = param.hasNoDefaultStyles, hasNoDefaultStyles = _hasNoDefaultStyles === void 0 ? false : _hasNoDefaultStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        priority: isPriority,
        className: "".concat(hasNoDefaultStyles ? "" : (_async_image_module_scss__WEBPACK_IMPORTED_MODULE_5___default().async_image), " ").concat((_async_image_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[imageClass], " ").concat(className || ""),
        loader: imageLoader,
        src: imgSrc || (0,_helpers_operators_helper__WEBPACK_IMPORTED_MODULE_4__/* .getCoverArtImage */ .QM)(coverArtId),
        alt: alt || "",
        width: width,
        height: height || width,
        layout: layout || (isFullWidth ? "responsive" : "fixed"),
        objectFit: objectFitStyle || "contain",
        loading: isPriority ? "eager" : "lazy",
        sizes: sizes,
        style: style
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AsyncImage);


/***/ }),

/***/ 29873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ userContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var userContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    user: null,
    setUser: function() {
        return null;
    },
    loggedIn: false,
    setLoggedIn: function() {
        return null;
    },
    setLoginModalState: function(state) {
        return state;
    },
    loginModalState: false,
    openLoginModal: function() {
        return null;
    },
    logout: function() {
        return null;
    },
    showAccountRecoverModal: function(state) {
        return state;
    },
    accountRecoverModalState: false
});



/***/ }),

/***/ 17909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68585);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_footer_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_grid_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23878);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19142);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_environment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69232);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93434);
/* harmony import */ var _components_auth_auth_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29873);
/* harmony import */ var _enums_amplitude__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8719);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34420);
/* harmony import */ var _components_async_image_async_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74528);











var Footer = function() {
    var auth = react__WEBPACK_IMPORTED_MODULE_1__.useContext(_components_auth_auth_context__WEBPACK_IMPORTED_MODULE_6__/* .userContext */ .x);
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)(), t = ref.t, i18n = ref.i18n;
    var lang = i18n.language;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPortrait = ref1[0], setIsPortrait = ref1[1];
    var androidLink = "https://play.google.com/store/apps/details?id=com.anghami&hl=en";
    var iosLink = "https://itunes.apple.com/us/app/anghami-%D8%A7%D9%86%D8%BA%D8%A7%D9%85%D9%8A/id545395155?mt=8";
    var desktopAppLink = "https://play.anghami.com/download";
    var onButtonClick = function() {
        var os = (0,_helpers_helper__WEBPACK_IMPORTED_MODULE_4__/* .getOS */ .Ij)();
        var redirectUrl = "";
        if (os === "iphone") {
            redirectUrl = iosLink;
        }
        if (os === "android") {
            redirectUrl = androidLink;
        }
        if (os === "web") {
            redirectUrl = desktopAppLink;
        }
        (0,_helpers_analytics__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_enums_amplitude__WEBPACK_IMPORTED_MODULE_7__/* .AmplitudeEvents.productsCTAClick */ .X.productsCTAClick, {
            button_text: "Download Now",
            button_url: redirectUrl
        });
        window.location.href = redirectUrl;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var updateWindowDimensions = function() {
            if (window.innerWidth < window.innerHeight && window.innerWidth <= 900) {
                setIsPortrait(true);
            } else {
                setIsPortrait(false);
            }
        };
        updateWindowDimensions();
        window.addEventListener("resize", updateWindowDimensions);
    }, []);
    // if user is logged in we show the expanded account page in mobile if not we show the get started page
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(auth.loggedIn ? 2 : 0), expandedIndex = ref2[0], setExpandedIndex = ref2[1];
    var sections = [
        {
            title: "footer_title_getstarted",
            collapsed: auth.loggedIn,
            sections: [
                {
                    title: "footer_getstarted_download",
                    link: "https://www.anghami.com/download"
                },
                {
                    title: "footer_getstarted_product",
                    link: "https://www.anghami.com/products"
                }
            ]
        },
        {
            title: "footer_title_company",
            collapsed: true,
            sections: [
                {
                    title: "footer_company_aboutus",
                    link: "https://www.anghami.com/about"
                },
                {
                    title: "footer_company_career",
                    link: "https://www.anghami.com/careers"
                },
                {
                    title: "footer_company_press",
                    link: "https://www.anghami.com/press"
                },
                {
                    title: "footer_company_talks",
                    link: "https://talks.anghami.com/"
                },
                {
                    title: "footer_company_kalimat",
                    link: "https://kalimat.anghami.com"
                },
                {
                    title: "footer_company_terms",
                    link: "https://www.anghami.com/legal"
                },
                {
                    title: "footer_company_osnplus",
                    link: "https://www.osnplus.com/"
                }
            ]
        },
        {
            title: "footer_title_account",
            collapsed: !auth.loggedIn,
            sections: [
                {
                    title: "Manage Your Account",
                    link: "https://www.anghami.com/manage-account"
                },
                {
                    title: "footer_account_redeem",
                    link: "https://www.anghami.com/redeem"
                },
                {
                    title: "footer_account_gift",
                    link: "https://www.anghami.com/gifts"
                },
                {
                    title: "footer_account_help",
                    link: "https://www.anghami.com/help"
                }
            ]
        },
        {
            title: "footer_title_communities",
            collapsed: true,
            sections: [
                {
                    title: "footer_communities_artists",
                    link: "https://www.anghami.com/artist-connect"
                },
                {
                    title: "footer_communities_podcasters",
                    link: "https://www.anghami.com/podcasters"
                },
                {
                    title: "footer_communities_advertisers",
                    link: "https://www.anghami.com/advertise"
                },
                {
                    title: "footer_communities_affiliate",
                    link: "https://www.anghami.com/affiliate"
                },
                {
                    title: "IR_landing_title",
                    link: "https://www.anghami.com/investors"
                },
                {
                    title: "footer_communities_corporateoffer",
                    link: "https://www.anghami.com/corporateoffer"
                },
                {
                    title: "footer_soundbox",
                    link: "https://www.anghami.com/soundbox"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_left_container),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                                    children: sections.map(function(section, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                                            xs: 12,
                                            md: 6,
                                            lg: 3,
                                            className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_container),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title),
                                                    onClick: function() {
                                                        if (index !== expandedIndex) {
                                                            setExpandedIndex(index);
                                                        } else {
                                                            setExpandedIndex(undefined);
                                                        }
                                                    },
                                                    children: [
                                                        t(section.title),
                                                        isPortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.web_cdn_url + "_next/static/icons/footer-arrow.svg",
                                                            alt: "footer-arrow",
                                                            width: "40",
                                                            height: "40",
                                                            className: "".concat((_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrow), " ").concat(index === expandedIndex && (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().rottated_arrow))
                                                        })
                                                    ]
                                                }),
                                                (expandedIndex === index || !isPortrait) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    children: section.sections.map(function(subSection) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: subSection.link,
                                                                children: t(subSection.title)
                                                            })
                                                        }, subSection.title);
                                                    })
                                                })
                                            ]
                                        }, section.title);
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_right_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().devices_container),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_async_image_async_image__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        imgSrc: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/footer-devices.png",
                                        alt: "Footer Image",
                                        width: 300,
                                        height: 100
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_button),
                                        type: "submit",
                                        onClick: onButtonClick,
                                        children: t("footer_cta")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_devices),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/for-apple.png",
                                        alt: "Apple Anghami",
                                        width: "40",
                                        height: "40"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: iosLink,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title2),
                                        children: [
                                            t("download_ios"),
                                            " \xa0 >"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_devices),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/for-android.png",
                                        alt: "Android Anghami",
                                        width: "40",
                                        height: "40"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: androidLink,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title2),
                                        children: [
                                            t("download_android"),
                                            " \xa0 >"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_devices),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/for-apple.png",
                                        alt: "Mac Anghami",
                                        width: "40",
                                        height: "40"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: desktopAppLink,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title2),
                                        children: [
                                            t("download_mac"),
                                            " \xa0 >"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_devices),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/for-windows.png",
                                        alt: "Windows Anghami",
                                        width: "40",
                                        height: "40"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: desktopAppLink,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title2),
                                        children: [
                                            t("download_web"),
                                            " \xa0 >"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bellow_footer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
                    className: "no-padding",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bellow_footer_row),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                                xs: 12,
                                md: 6,
                                lg: 3,
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_bottom_row),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().logo),
                                    src: "".concat(_environment__WEBPACK_IMPORTED_MODULE_3__.environment.web_cdn_url, "web/assets/img/").concat(lang === "ar" ? "logos/Logo_Horizontal_AR_colored_DarkMode.png" : "new-anghami-logos/header-logo-colored.png"),
                                    alt: "Anghami",
                                    decoding: "async"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                                xs: 12,
                                md: 6,
                                lg: 3,
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_bottom_row),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title2),
                                        children: t("language")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_language_selector),
                                        value: i18n.language,
                                        onChange: function(event) {
                                            var lang = event.target.value;
                                            (0,_helpers_helper__WEBPACK_IMPORTED_MODULE_4__/* .setLanguageCookies */ .zb)(lang, null);
                                            setTimeout(function() {
                                                i18n.changeLanguage(lang, function() {
                                                    window.location.href = (0,_helpers_helper__WEBPACK_IMPORTED_MODULE_4__/* .updateQueryString */ .bj)("lang", lang, window.location.href);
                                                });
                                            }, 5);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "en",
                                                children: "English"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "ar",
                                                children: "عربي"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "fr",
                                                children: "Fran\xe7ais"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                                xs: 12,
                                md: 6,
                                lg: 3,
                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_social_container),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footer_section_title2),
                                        children: t("footer_social_text")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default().social_icons_constainer),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://www.twitter.com/anghami",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["social-icon"]),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/twitter-logo.svg",
                                                    alt: "Twitter Anghami",
                                                    width: "40",
                                                    height: "40"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://www.instagram.com/anghami",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["social-icon"]),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/instagram-logo.svg",
                                                    alt: "Instagram Anghami",
                                                    width: "40",
                                                    height: "40"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://www.facebook.com/anghami",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: (_footer_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["social-icon"]),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: _environment__WEBPACK_IMPORTED_MODULE_3__.environment.images_cdn_url + "/footer/facebook-logo.svg",
                                                    alt: "Facebook Anghami",
                                                    width: "40",
                                                    height: "40"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isPortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_grid_system__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                                xs: 12,
                                md: 6,
                                lg: 3
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 76459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ef": function() { return /* binding */ setOperatorDetails; },
/* harmony export */   "Lt": function() { return /* binding */ filterParams; },
/* harmony export */   "QM": function() { return /* binding */ getCoverArtImage; },
/* harmony export */   "as": function() { return /* binding */ reportConversion; },
/* harmony export */   "ok": function() { return /* binding */ autofillPhoneNumber; },
/* harmony export */   "r$": function() { return /* binding */ subscribeOperator; },
/* harmony export */   "t6": function() { return /* binding */ getOperatorType; },
/* harmony export */   "vN": function() { return /* binding */ getOperatorData; }
/* harmony export */ });
/* unused harmony export setMsidnDetails */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59312);
/* harmony import */ var _anghami_neogateway_dist_endpoints_postPurchaseTelco__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62461);
/* harmony import */ var _anghami_neogateway_dist_endpoints_subscribePreorder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96686);
/* harmony import */ var _anghami_neogateway_dist_endpoints_getPreorder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82265);
/* harmony import */ var _anghami_neogateway_dist_endpoints_getTelcoConcert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37587);
/* harmony import */ var _neogateway__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23750);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69232);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34420);
/* harmony import */ var _enums_amplitude__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8719);
/* harmony import */ var _anghami_neogateway_dist_endpoints_getRbtInfo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72090);
/* harmony import */ var _anghami_neogateway_dist_endpoints_getOperatorPlan__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50784);
/* harmony import */ var _anghami_neogateway_dist_endpoints_postPurchaseTelcoAnghami__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10582);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19142);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_environment__WEBPACK_IMPORTED_MODULE_11__);
















// Types of operators available
var operatorType = [
    "default",
    "rbt",
    "preorder",
    "concerts"
];
var baseCoverUrl = _environment__WEBPACK_IMPORTED_MODULE_11__.environment.artwork_cdn_url;
var getOperatorType = function(operatorname) {
    var type = operatorType.find(function(elt) {
        return elt === operatorname.toLowerCase();
    });
    if (type) {
        return type;
    }
    return "default";
};
var setMsidnDetails = function(plan) {
    var validations = {};
    if (checkOperatorValidationsExist(plan)) {
        validations = {
            min_digits: plan.min_digits,
            max_digits: plan.max_digits,
            countrycode: plan.country_code
        };
    }
    return validations;
};
var checkOperatorValidationsExist = function(plan) {
    return plan.min_digits && plan.max_digits && plan.country_code;
};
var autofillPhoneNumber = function(msidn, isAutoSub, countrycode) {
    var mobilenum = "";
    if (msidn) {
        var msidncode = msidn.substring(0, 3);
        if (msidncode === countrycode || isAutoSub) {
            mobilenum = msidn.replace(/^.{3}/g, "");
        }
    }
    return mobilenum;
};
var filterParams = function(params) {
    Object.keys(params).forEach(function(key) {
        return (params[key] === undefined || params[key] === null || typeof params[key] === "object" && Object.keys(params[key]).length === 0) && delete params[key];
    });
};
var setOperatorDetails = function(data, params) {
    data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, data), {
        coverImageUrl: getCoverArtImage(data.coverartid, data.coverartsize)
    });
    return setOperatorMobileDetails(data, params);
};
// TODO: change name of function later on to something more meaningful
var setOperatorMobileDetails = function(data, params) {
    var plan = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, data), {
        operatorname: data.operatorname ? (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .handleArabicEncoding */ .$t)(data.operatorname) : undefined
    });
    var msidn = data.msidn && data.msidn !== null && data.msidn !== "" ? data.msidn : params.msidn || "";
    return {
        plan: plan,
        mode: data ? data.mode : null,
        mobilenumber: autofillPhoneNumber(msidn, false, data.country_code),
        isSms: plan.api === "sms" || data.purchase_method === "sms",
        step: plan.api === "sms" ? "" : "operator",
        redirectUrl: plan.redirect_url || "",
        phoneValidations: setMsidnDetails(data) // this._subOperatorService.msidnValidations
    };
};
/*
 * @param coverArtImage cover art image data attribute
 * @param size image size, defaults to 296
 * @description returns the proper url to render the cover art image
 */ var getCoverArtImage = function(coverArtImage) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 296;
    if (isNaN(Number(coverArtImage))) {
        return decodeURIComponent(coverArtImage);
    }
    return "".concat(baseCoverUrl, "?id=").concat(coverArtImage, "&size=").concat(size);
};
/**
 * @description Based on operator type, fetch initial data to output (header, partner, etc.)
 */ var getOperatorData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(type, params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(type){
                case "preorder":
                    {
                        return [
                            2,
                            _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_getPreorder__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, params)
                        ];
                    }
                case "concerts":
                    {
                        return [
                            2,
                            _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_getTelcoConcert__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, params)
                        ];
                    }
                case "rbt":
                    {
                        return [
                            2,
                            _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_getRbtInfo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, params)
                        ];
                    }
                default:
                    return [
                        2,
                        _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_getOperatorPlan__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, params)
                    ];
            }
            return [
                2
            ];
        });
    });
    return function getOperatorData(type, params) {
        return _ref.apply(this, arguments);
    };
}();
var subscribeTelco = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(params, language) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, params);
            delete data.type;
            if (params.type === "koussa") {
                return [
                    2,
                    _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_postPurchaseTelcoAnghami__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, data, true, null, {
                        language: language
                    })
                ];
            }
            return [
                2,
                _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.post */ .Y0.post(params.type, data, data)
            ];
        });
    });
    return function subscribeTelco(params, language) {
        return _ref.apply(this, arguments);
    };
}();
var subscribeOperator = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(type, params, language) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(type){
                case "preorder":
                    {
                        return [
                            2,
                            _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_subscribePreorder__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, params)
                        ];
                    }
                case "concerts":
                    {
                        return [
                            2,
                            _neogateway__WEBPACK_IMPORTED_MODULE_4__/* .gateway.callEndpoint */ .Y0.callEndpoint(_anghami_neogateway_dist_endpoints_postPurchaseTelco__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, params, false)
                        ];
                    }
                default:
                    return [
                        2,
                        subscribeTelco(params, language)
                    ];
            }
            return [
                2
            ];
        });
    });
    return function subscribeOperator(type, params, language) {
        return _ref.apply(this, arguments);
    };
}();
var reportConversion = function(amplitudeProps) {
    (0,_analytics__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_enums_amplitude__WEBPACK_IMPORTED_MODULE_7__/* .AmplitudeEvents.subscriptionSuccess */ .X.subscriptionSuccess, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, amplitudeProps), {
        type: "Success"
    }));
};


/***/ }),

/***/ 50784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getOperatorPlan; }
/* harmony export */ });
var ENDPOINT = "GEToperatorplan";
function getOperatorPlan(gateway) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gateway.get(getOperatorPlan.endpoint, params);
}
getOperatorPlan.endpoint = ENDPOINT;
 //# sourceMappingURL=getOperatorPlan.js.map


/***/ }),

/***/ 82265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getPreorder; }
/* harmony export */ });
var ENDPOINT = "GETpreorder";
function getPreorder(gateway) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gateway.get(getPreorder.endpoint, params);
}
getPreorder.endpoint = ENDPOINT;
 //# sourceMappingURL=getPreorder.js.map


/***/ }),

/***/ 72090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getRbtInfo; }
/* harmony export */ });
var ENDPOINT = "GETrbtinfo";
function getRbtInfo(gateway) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gateway.get(getRbtInfo.endpoint, params);
}
getRbtInfo.endpoint = ENDPOINT;
 //# sourceMappingURL=getRbtInfo.js.map


/***/ }),

/***/ 37587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTelcoConcert; }
/* harmony export */ });
var ENDPOINT = "GETtelcoconcert";
function getTelcoConcert(gateway) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gateway.get(getTelcoConcert.endpoint, params);
}
getTelcoConcert.endpoint = ENDPOINT;
 //# sourceMappingURL=getTelcoConcert.js.map


/***/ }),

/***/ 62461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ postPurchaseTelco; }
/* harmony export */ });
var ENDPOINT = "POSTpurchasetelco";
function postPurchaseTelco(gateway) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gateway.get(postPurchaseTelco.endpoint, params);
}
postPurchaseTelco.endpoint = ENDPOINT;
 //# sourceMappingURL=postPurchaseTelco.js.map


/***/ }),

/***/ 10582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ postPurchaseTelcoAnghami; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59312);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53975);


var KOUSSA_ENDPOINT = "post-purchase-telco-anghami";
function postPurchaseTelcoAnghami(gateway, params) {
    var customURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, customHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, isKoussa = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .mG)(this, void 0, void 0, function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            return [
                2,
                gateway.post(postPurchaseTelcoAnghami.koussaEndpoint, isKoussa ? {} : params, params, customURL, customHeaders, null, isKoussa)
            ];
        });
    });
}
postPurchaseTelcoAnghami.koussaEndpoint = KOUSSA_ENDPOINT;
 //# sourceMappingURL=postPurchaseTelcoAnghami.js.map


/***/ }),

/***/ 96686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subscribePreorder; }
/* harmony export */ });
var ENDPOINT = "SUBSCRIBEpreorder";
function subscribePreorder(gateway) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gateway.get(subscribePreorder.endpoint, params);
}
subscribePreorder.endpoint = ENDPOINT;
 //# sourceMappingURL=subscribePreorder.js.map


/***/ }),

/***/ 38992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"async-image_d-flex__AW96y","f-column":"async-image_f-column__cos9j","f-justify-center":"async-image_f-justify-center__tK4Ru","f-justify-between":"async-image_f-justify-between__M6hUy","f-justify-start":"async-image_f-justify-start__SSrqG","f-justify-end":"async-image_f-justify-end__D_wQ0","f-align-center":"async-image_f-align-center__j2BHu","f-align-start":"async-image_f-align-start__z5vnL","f-align-stretch":"async-image_f-align-stretch__Epd5i","f-align-end":"async-image_f-align-end__B5P2k","f-center":"async-image_f-center___J6r0","position-relative":"async-image_position-relative__9Nqaf","w-100":"async-image_w-100__NYQyQ","async_image":"async-image_async_image__nd4Is","async_image_circle":"async-image_async_image_circle__okWAL"};

/***/ }),

/***/ 68585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"footer_d-flex__NVGhe","f-column":"footer_f-column__vLnyo","f-justify-center":"footer_f-justify-center__Ry_Ee","f-justify-between":"footer_f-justify-between__v34F_","f-justify-start":"footer_f-justify-start__n4u_7","f-justify-end":"footer_f-justify-end__tghA3","f-align-center":"footer_f-align-center__nda_p","f-align-start":"footer_f-align-start__kYi_0","f-align-stretch":"footer_f-align-stretch__y62LT","f-align-end":"footer_f-align-end__8FEjj","f-center":"footer_f-center__5H7Dt","position-relative":"footer_position-relative__o3ut0","w-100":"footer_w-100__JB5ak","footer_container":"footer_footer_container__7EDlW","footer":"footer_footer__LV2HF","bellow_footer":"footer_bellow_footer__sq2MB","download":"footer_download__yFR3B","coltitle":"footer_coltitle__vViOJ","social-icon":"footer_social-icon__OO9dP","footer_section_title":"footer_footer_section_title__IwxCn","footer_section_title2":"footer_footer_section_title2__vJ2Di","footer_language_selector":"footer_footer_language_selector__g1EVN","footer_left_container":"footer_footer_left_container__6CsjZ","footer_right_container":"footer_footer_right_container__4QsLK","footer_button":"footer_footer_button__RmyCD","footer_social_container":"footer_footer_social_container__2xMmh","social_icons_constainer":"footer_social_icons_constainer__qFOFx","footer_bottom_row":"footer_footer_bottom_row__5T2uz","footer_image":"footer_footer_image__MeKOL","footer_devices":"footer_footer_devices__Zakuc","devices_container":"footer_devices_container___mpvv","footer_section_container":"footer_footer_section_container__7qx9Y","arrow":"footer_arrow__aPqJU","rottated_arrow":"footer_rottated_arrow__VpLgu","logo":"footer_logo__ElLXN","bellow_footer_row":"footer_bellow_footer_row__aOHAn"};

/***/ }),

/***/ 58772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(90331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 23615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(58772)();
}


/***/ }),

/***/ 90331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

}]);